"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFieldWidth = getFieldWidth;
function getFieldWidth(fullWidth) {
    return fullWidth ? "100%" : "550px";
}
